module.exports = __webpack_public_path__ + "img/faq-icon.0f315851.svg";